// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import { getListCustomerQuickBooks, getAuthUrlQuickBooks, disconnectQuickBooks } from './quickBooksThunk';

export interface IQuickBooksState {
  isRefreshCustomerQuickBooksList: boolean;
}

export const initialState: IQuickBooksState = {
  isRefreshCustomerQuickBooksList: false,
};

const quickBooksSlice = createSlice({
  name: 'quickBooks',
  initialState,
  reducers: {
    setRefreshCustomerQuickBooksList: (state, action) => {
      state.isRefreshCustomerQuickBooksList = action.payload;
    },
  },
  extraReducers: (builder) => {
    // GET: Get list customer QuickBooks
    builder
      .addCase(getListCustomerQuickBooks.pending, (_state) => {})
      .addCase(getListCustomerQuickBooks.fulfilled, (_state) => {})
      .addCase(getListCustomerQuickBooks.rejected, (_state) => {});

    // GET: Get auth URL QuickBooks
    builder
      .addCase(getAuthUrlQuickBooks.pending, (_state) => {})
      .addCase(getAuthUrlQuickBooks.fulfilled, (_state) => {})
      .addCase(getAuthUrlQuickBooks.rejected, (_state) => {});

    // POST: Disconnect QuickBooks
    builder
      .addCase(disconnectQuickBooks.pending, (_state) => {})
      .addCase(disconnectQuickBooks.fulfilled, (_state) => {})
      .addCase(disconnectQuickBooks.rejected, (_state) => {});
  },
});

// Action
export const quickBooksActions = quickBooksSlice.actions;

// Selectors
export const selectIsRefreshCustomerQuickBooksList = (state: RootState) =>
  state.quickBooks.isRefreshCustomerQuickBooksList;

// Reducer
const quickBooksReducer = quickBooksSlice.reducer;
export default quickBooksReducer;
